// API base URL - uses environment variable or falls back to '/api' for dev proxy
const API_URL =
    import.meta.env.VITE_API_URL || '/api';

// Helper function to get auth token
const getAuthToken = () => localStorage.getItem('token');

// Helper function to make authenticated requests
const authFetch = async(url, options = {}) => {
    const token = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
    };

    const fullUrl = `${API_URL}${url}`;
    console.log('API Request:', fullUrl, options.method || 'GET');

    const response = await fetch(fullUrl, {
        ...options,
        headers,
    });

    console.log('API Response:', response.status, response.statusText);

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Request failed' }));
        console.error('API Error:', error);
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('API Data:', data);
    return data;
};

export const api = {
    // Auth
    login: async(email, password) => {
        return authFetch('/auth/login', {
            method: 'POST',
            body: JSON.stringify({ email, password }),
        });
    },

    register: async(userData) => {
        return authFetch('/auth/register', {
            method: 'POST',
            body: JSON.stringify(userData),
        });
    },

    // Users
    getUsers: async() => {
        return authFetch('/users');
    },

    approveUser: async(userId) => {
        return authFetch(`/users/${userId}/approve`, {
            method: 'PATCH',
        });
    },

    deleteUser: async(userId) => {
        return authFetch(`/users/${userId}`, {
            method: 'DELETE',
        });
    },

    // Orders
    getOrders: async() => {
        return authFetch('/orders');
    },

    createOrder: async(orderData) => {
        return authFetch('/orders', {
            method: 'POST',
            body: JSON.stringify(orderData),
        });
    },

    updateOrder: async(orderId, orderData) => {
        return authFetch(`/orders/${orderId}`, {
            method: 'PUT',
            body: JSON.stringify(orderData),
        });
    },

    deleteOrder: async(orderId) => {
        return authFetch(`/orders/${orderId}`, {
            method: 'DELETE',
        });
    },

    // Prices
    getPrices: async() => {
        return authFetch('/prices');
    },

    createPrice: async(priceData) => {
        return authFetch('/prices', {
            method: 'POST',
            body: JSON.stringify(priceData),
        });
    },

    updatePrice: async(priceId, priceData) => {
        return authFetch(`/prices/${priceId}`, {
            method: 'PUT',
            body: JSON.stringify(priceData),
        });
    },

    deletePrice: async(priceId) => {
        return authFetch(`/prices/${priceId}`, {
            method: 'DELETE',
        });
    },

    // Brand Images
    getBrandImages: async() => {
        return authFetch('/images');
    },

    uploadBrandImage: async(imageData) => {
        return authFetch('/images', {
            method: 'POST',
            body: JSON.stringify(imageData),
        });
    },

    deleteBrandImage: async(imageId) => {
        return authFetch(`/images/${imageId}`, {
            method: 'DELETE',
        });
    },
};

// Export individual API modules for convenience
export const usersAPI = {
    getAll: api.getUsers,
    approve: api.approveUser,
    delete: api.deleteUser,
};

export const ordersAPI = {
    getAll: api.getOrders,
    create: api.createOrder,
    update: api.updateOrder,
    delete: api.deleteOrder,
};

export const imagesAPI = {
    getAll: api.getBrandImages,
    upload: api.uploadBrandImage,
    delete: api.deleteBrandImage,
};